export const collaboratorRole = [
  'adv',
  'adv-distanciel',
  'responsable-magasin',
  'chef-secteur',
  'responsable-regional-reseau',
  'responsable-animation-ventes-distance',
  'agent-de-securite',
  'manager-experience-client',
  // Rôles logistiques : rattachés à un atelier ou à un hub, jamais à une boutique.
  'chauffeur',
  'preparateur-hub',
  'responsable-hub',
] as const
export type CollaboratorRole = (typeof collaboratorRole)[number]

export const collaboratorRoleLabel: Record<CollaboratorRole, string> = {
  adv: 'Animateur des Ventes',
  'adv-distanciel': 'Animateur des Ventes - Distanciel',
  'responsable-magasin': 'Manager de Boutiques',
  'chef-secteur': 'Responsable de Secteur',
  'responsable-regional-reseau': 'Responsable régional de réseau',
  'responsable-animation-ventes-distance': 'Responsable animation des ventes à distance',
  'agent-de-securite': 'Agent de sécurité',
  'manager-experience-client': 'Manager expérience client',
  chauffeur: 'Chauffeur',
  'preparateur-hub': 'Préparateur Hub',
  'responsable-hub': 'Responsable de hub',
}

/**
 * Rôles de la brique logistique. Un collaborateur qui porte l'un d'eux est rattaché à exactement
 * un atelier ou un hub (`collaborators_logistics_role_home` en base), lieu de départ et de retour
 * de ses tournées. Liste tenue en miroir du CHECK en base : l'un ne change pas sans l'autre.
 */
export const logisticsCollaboratorRoles = [
  'chauffeur',
  'preparateur-hub',
  'responsable-hub',
] as const satisfies readonly CollaboratorRole[]
export type LogisticsCollaboratorRole = (typeof logisticsCollaboratorRoles)[number]

export const isLogisticsCollaboratorRole = (
  role: string | null | undefined,
): role is LogisticsCollaboratorRole =>
  (logisticsCollaboratorRoles as readonly string[]).includes(role ?? '')

export const managerCollaboratorRoles = [
  'chef-secteur',
  'responsable-magasin',
  'responsable-regional-reseau',
  'responsable-animation-ventes-distance',
] as const satisfies readonly CollaboratorRole[]

export const isManagerCollaboratorRole = (role: string | null | undefined): boolean =>
  (managerCollaboratorRoles as readonly string[]).includes(role ?? '')

// Pas de N+1 obligatoire pour les rôles au sommet de la hiérarchie (directeur / gérant), ni pour
// les rôles logistiques (un chauffeur prestataire n'a pas de manager chez Lucie).
// Pour tous les autres rôles, le manager (managerId) reste requis.
export const rolesWithoutMandatoryManager: CollaboratorRole[] = [
  'responsable-magasin',
  'chef-secteur',
  'responsable-regional-reseau',
  ...logisticsCollaboratorRoles,
]
